import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

export const StyledCookiesContainer = styled.div`
    ${() => `
    position: fixed;
    inset: 0;
    z-index: 99999;

    background-color: rgba(255, 255, 255, 0.4);
    -webkit-backdrop-filter: blur(2px);
    backdrop-filter: blur(2px);
    `}
`;

export const StyledPaper = styled(Paper)`
    ${({ theme }) => `
    border-radius: 40px;

    padding: 25px 20px;
    ${theme.breakpoints.up('sm')} {
        padding: 45px 45px 40px;
    }
    `}
`;

export const StyledDialogContentContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    flex-direction: column;

    row-gap: 30px;
    ${theme.breakpoints.up('md')} {
        row-gap: 50px;
    }
    `}
`;

export const StyledCookiesDialogButtonContainer = styled.div`
    ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items:center;
    row-gap: 10px;

    flex-direction: column;
    ${theme.breakpoints.up('sm')} {
        flex-direction: row;
    }
    `}
`;

export const StyledCookiesCard = styled.div`
    ${({ theme }) => `
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;

    max-width: 913px;
    z-index: 99999;

    background: #FFFFFF;
    align-items: center;
    box-shadow: 0px 4px 24px rgba(67, 67, 67, 0.18);
    border-radius: 40px;

    display: flex;

    flex-direction: column;
    column-gap: 10px;
    row-gap: 15px;
    padding: 20px 25px;
    ${theme.breakpoints.up('sm')} {
        flex-direction: row;
    }
    ${theme.breakpoints.up('md')} {
        column-gap: 20px;
        padding: 30px;
    }
    `}
`;

export const StyledCookiesContent = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    row-gap: 15px;
    `}
`;

export const StyledCookiesButtonContainer = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    `}
`;

export const StyledButton = styled(Button)`
    ${() => `
    border-radius: 8px;
    padding: 6px 14px;

    width: 220px;
    height: 48px;
    `}
`;
